var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigatePrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.167,
    height: 16.464,
    viewBox: "0 0 10.167 16.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        \r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-navigate-next",
    "data-name": "Icon material-navigate-next",
    className: "cls-1",
    d: "M1.935,0,0,1.935l6.284,6.3L0,14.53l1.935,1.935,8.232-8.232Z",
    transform: "translate(10.167 16.464) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigatePrev);
export default __webpack_public_path__ + "static/media/navigate-prev.f95d6d97b78d9925495ed47ccd19a360.svg";
export { ForwardRef as ReactComponent };